import jwt_decode from "jwt-decode";

export const useTokenPayload = {
  computed: {
    email() {
      const token = localStorage.getItem("token");
      const { userEmail } = jwt_decode(token);
      return userEmail;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/useTokenPayload.js